import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`dark-header fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled ? 'bg-black/80 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-[7.6923%] flex items-center justify-between h-20">
        <Link to="/" className="flex items-center">
          <img 
            src="/logo.png" 
            alt="NotchUp Virtual Tours" 
            className="h-12 object-contain cursor-pointer transition-transform duration-300 hover:scale-105"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('about')} className="dark-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('services')} className="dark-nav-link">
            Services
          </button>
          <button onClick={() => scrollToSection('gallery')} className="dark-nav-link">
            Gallery
          </button>
          <button onClick={() => scrollToSection('process')} className="dark-nav-link">
            Process
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="dark-nav-link">
            Testimonials
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
            Contact
          </button>
        </nav>

        <div className="hidden md:block">
          <Button 
            onClick={() => scrollToSection('contact')}
            className="btn-primary"
          >
            Get Started
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 right-0 bg-black/95 backdrop-blur-lg border-t border-white/25">
          <nav className="flex flex-col p-6 gap-4">
            <button onClick={() => scrollToSection('about')} className="dark-nav-link text-left py-2">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="dark-nav-link text-left py-2">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="dark-nav-link text-left py-2">
              Gallery
            </button>
            <button onClick={() => scrollToSection('process')} className="dark-nav-link text-left py-2">
              Process
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="dark-nav-link text-left py-2">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="dark-nav-link text-left py-2">
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary mt-4"
            >
              Get Started
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
